import { Box, Typography, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ILot } from 'types/lots'
import { Edit } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

type Props = {
  lot: ILot
  isDisabled?: boolean
}

export const LotCard = ({ lot, isDisabled = false }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Box
      bgcolor="#FFFFFF"
      padding={2}
      borderRadius={1}
      marginTop={2}
      borderLeft={4}
      borderColor="primary.main"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      boxShadow={2}
    >
      <Box>
        <Typography variant="caption" fontWeight="bold">
          {t('name')}:
        </Typography>
        <Typography variant="body2">{lot.name}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" fontWeight="bold">
          {t('predicted-price')}:
        </Typography>
        <Typography variant="body2">{lot.estimatedPriceAmount ?? '-'}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" fontWeight="bold">
          {t('participation-fee')}:
        </Typography>
        <Typography variant="body2">{lot.participationFeeAmount ?? '-'}</Typography>
      </Box>

      {!isDisabled && (
        <IconButton
          aria-label="edit lot"
          color="primary"
          onClick={() =>
            navigate(`/portal/tenders/${lot.tenderId}/lot/${lot.id}/edit`)
          }
        >
          <Edit />
        </IconButton>
      )}
    </Box>
  )
}
